import { ListingResource, useListingStore } from '@brightmls/nextgen.lae.flc';
import { PropertyField } from '../../../../system/field';
import {
  Field,
  FieldsList,
  ListingState,
  ListingStateKey,
  RadioGroupTypes,
  RecordValue,
} from './types';

export const isRecordEnabled = (
  recordId: string,
  state: ListingState,
): boolean => {
  if (state && recordId) {
    const enabledRecords = state[ListingStateKey.ENABLED_RECORDS] || {};
    return !!enabledRecords[recordId]?.isEnabled;
  }
  return false;
};

export const countRecordData = (fields: FieldsList) => {
  return Object.values(fields).reduce((acc: any, field: Field) => {
    Object.keys(field.recordData || {}).forEach((key: string) => {
      if (acc[key]) acc[key]++;
      if (!acc[key]) acc[key] = 1;
      return acc;
    });
    return acc;
  }, {});
};

export const getRecordType = (
  recordId: string,
  state: ListingState,
  type?: string,
) => {
  const enabledRecords = state[ListingStateKey.ENABLED_RECORDS];
  const recordType = enabledRecords[recordId]?.type;
  if (recordType) {
    return type ? recordType === type : recordType;
  }
  return null;
};

export const getStateValueFromRecord = (
  state: ListingState,
  fieldKey: PropertyField | string,
  currentValue: RecordValue,
): RecordValue => {
  const { recordId, value } = currentValue;
  let newValue = value;

  if (recordId === RadioGroupTypes.CUSTOM) {
    // Directly access the listing store
    const listingStore = useListingStore.getState();

    // Get the current field value from the store
    newValue = listingStore.getResourceFieldValue(
      ListingResource.Property,
      fieldKey as string,
      null,
    );
  }

  return {
    recordId: recordId,
    value: newValue,
  };
};
